import { render } from "./ClinimetricsTile.vue?vue&type=template&id=9f183e12&scoped=true"
import script from "./ClinimetricsTile.vue?vue&type=script&lang=js"
export * from "./ClinimetricsTile.vue?vue&type=script&lang=js"

import "./ClinimetricsTile.vue?vue&type=style&index=0&id=9f183e12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f183e12"]])

export default __exports__